import { useEffect, useRef } from "react";
import { useSearchResult } from "../api/useSearchResult";
import { Button, Pagination } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useNotificationsStore } from "@src/entities/notifications/model/store/notificationsStore";

import styles from "./styles.module.scss";
import { SearchResultContainer } from "./SearchResultContainer";

export const SearchReasult = () => {
  const { items, total, page, limit, isLoading, getSearchResult } =
    useSearchResult();
  const location = useLocation();
  const lastLiveEvent = useNotificationsStore((s) => s.lastLiveEvent);
  const handledLiveEventIdRef = useRef<string | null>(null);

  const targetRequestUuid = location.state?.requestUuid as string | undefined;
  const totalPages = Math.ceil(total / limit);

  useEffect(() => {
    getSearchResult(1);
  }, []);

  useEffect(() => {
    if (!targetRequestUuid || !items.length) return;

    const element = document.getElementById(`request-${targetRequestUuid}`);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [targetRequestUuid, items]);

  useEffect(() => {
    if (!lastLiveEvent) return;

    if (handledLiveEventIdRef.current === lastLiveEvent.id) return;

    if (lastLiveEvent.type === "MATCHING_REQUEST_DONE") {
      handledLiveEventIdRef.current = lastLiveEvent.id;
      getSearchResult(1, false);
    }
  }, [lastLiveEvent, getSearchResult]);

  const loadMore = () => {
    if (page < totalPages) {
      getSearchResult(page + 1, true);
    }
  };

  const handlePageChange = (_: any, newPage: number) => {
    if (newPage !== page) {
      getSearchResult(newPage, false);
    }
  };

  const isShowResult = !!items.length;

  return (
    <div className={styles.searchResult}>
      {isLoading && page === 1 && <div>Загрузка...</div>}

      {!isLoading && !items.length && <div>Результаты отсутствуют</div>}

      {isShowResult &&
        items.map((item) => <SearchResultContainer item={item} />)}

      {isShowResult && (
        <>
          <Button
            onClick={loadMore}
            className={styles.showMoreBtn}
            disabled={page === totalPages}
          >
            Показать ещё
          </Button>

          <div className={styles.paginationWrapper}>
            <div className={styles.showItems}>
              <span>{`Показывается ${items.length} из ${total}`}</span>
            </div>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
            />
          </div>
        </>
      )}
    </div>
  );
};
